import {
    GET_TRANSACTIONFEE_INFO_LOADING, TRANSACTIONFEE_DATA_SUCCESS,
    TRANSACTIONFEE_DATA_ERROR, TRANSACTIONFEE_DATA_RESET
} from "../actions/actionTransactionFee";
import { loadState, saveState } from "../helpers/sessionStorage";

const sessionKey1 = "transactionFee";

const initialState = {
    transactionFee: loadState(sessionKey1, []),
    loading: false,
    transactionFeeError: ''
};

function reducerTransactionFee(state = initialState, action) {

    switch (action.type) {
        case GET_TRANSACTIONFEE_INFO_LOADING: {
            return {
                ...state,
                loading: true
            };
        }


        case TRANSACTIONFEE_DATA_SUCCESS: {

            saveState(sessionKey1, action.payload)

            return {
                ...state,
                transactionFee: action.payload,
                transactionFeeError: ''
            };
        }

        case TRANSACTIONFEE_DATA_RESET: {

            saveState(sessionKey1, [])

            return {
                ...state,
                transactionFee: [],
                transactionFeeError: ''
            };
        }

        case TRANSACTIONFEE_DATA_ERROR: {

            saveState(sessionKey1, action.payload)

            return {
                ...state,
                loading: false,
                transactionFeeError: action.error
            }
        }

        default: {
            return state;
        }
    }
}

export default reducerTransactionFee;